/* Customer Proof Carousel — progressive enhancement.
   Cards are a CSS scroll-snap row and work with no JS (horizontal scroll +
   touch swipe). This only adds prev/next arrows on pointer/desktop and keeps
   their disabled state in sync with scroll position. Idempotent per section. */
(function () {
  'use strict';

  function enhance(section) {
    if (section.dataset.cpcReady === '1') return;
    section.dataset.cpcReady = '1';

    var track = section.querySelector('[data-cpc-track]');
    var prev = section.querySelector('[data-cpc-prev]');
    var next = section.querySelector('[data-cpc-next]');
    if (!track || !prev || !next) return;

    // Only surface arrows when content actually overflows and a fine pointer
    // is available (touch devices use native swipe).
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function overflowing() { return track.scrollWidth - track.clientWidth > 4; }

    function step() {
      var card = track.querySelector('.cpc__card');
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '20', 10) || 20;
      var w = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      return (w + gap) * Math.max(1, Math.floor(track.clientWidth / (w + gap)));
    }

    function sync() {
      var show = finePointer && overflowing();
      prev.hidden = !show;
      next.hidden = !show;
      if (!show) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sync();
  }

  function init() {
    var sections = document.querySelectorAll('[data-cpc]');
    for (var i = 0; i < sections.length; i++) enhance(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-editor support: re-run when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('[data-cpc]') : null;
    if (s) { s.dataset.cpcReady = ''; enhance(s); }
  });
})();
